import z from 'zod';
import { ExpressionOrJsonValueSchema } from './Options.js';
export var EntityModelType;
(function (EntityModelType) {
    EntityModelType["Action"] = "action";
    EntityModelType["Feedback"] = "feedback";
})(EntityModelType || (EntityModelType = {}));
export var FeedbackEntitySubType;
(function (FeedbackEntitySubType) {
    FeedbackEntitySubType["Boolean"] = "boolean";
    FeedbackEntitySubType["Advanced"] = "advanced";
    FeedbackEntitySubType["Value"] = "value";
    FeedbackEntitySubType["StyleOverride"] = "style-override";
})(FeedbackEntitySubType || (FeedbackEntitySubType = {}));
export function isValidFeedbackEntitySubType(value) {
    return Object.values(FeedbackEntitySubType).includes(value);
}
export function isInternalUserValueFeedback(entity) {
    return (entity.type === EntityModelType.Feedback &&
        entity.connectionId === 'internal' &&
        entity.definitionId === 'user_value');
}
export const schemaFeedbackEntityStyleOverride = z.object({
    overrideId: z.string(),
    elementId: z.string(),
    elementProperty: z.string(),
    override: ExpressionOrJsonValueSchema,
});
const zodActionSetId = z.union([
    z.literal('down'),
    z.literal('up'),
    z.literal('rotate_left'),
    z.literal('rotate_right'),
    z.number(),
]);
export const zodEntityLocation = z.union([
    z.literal('feedbacks'),
    z.literal('trigger_actions'),
    z.literal('local-variables'),
    z.object({
        stepId: z.string(),
        setId: zodActionSetId,
    }),
]);
export function stringifySocketEntityLocation(location) {
    if (typeof location === 'string')
        return location;
    return `${location.stepId}_${location.setId}`;
}
//# sourceMappingURL=EntityModel.js.map